"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteDetailSchema = exports.LayerNodeSchema = void 0;
const zod_1 = require("zod");
exports.LayerNodeSchema = zod_1.z.lazy(() => zod_1.z.object({
    name: zod_1.z.string(),
    id: zod_1.z.string(),
    layerName: zod_1.z.string(),
    children: zod_1.z.array(exports.LayerNodeSchema),
}));
//Site Token
exports.SiteDetailSchema = zod_1.z.object({
    siteName: zod_1.z.string(),
    location: zod_1.z.string(),
    children: zod_1.z.array(exports.LayerNodeSchema)
});
